import { useConfig } from '../../context/ConfigProvider/ConfigProvider';
export const useIsErrorTestAttribute = (isError) => {
    const { isErrorTestAttributeName } = useConfig();
    return { [isErrorTestAttributeName]: isError };
};
